<script setup>
import { defineProps, defineEmits } from 'vue';
import { Gems } from '../gems';
import { MESSAGES } from '../messages';

const props = defineProps({
    showValidationTypeModal: Boolean,
    ratingData: Object,
    element: Object
});

const emit = defineEmits(['close-modal']);

function requestValidation(byCertificate = false) {
    if(byCertificate && !props.element.has_files) {
        Gems.Telegram(MESSAGES.ERROR.WITHOUT_FILE, 'tele-not-allowed')
        emit('close-modal')
        return
    }
    
    props.ratingData.RequestValidation(props.element, byCertificate)
    emit('close-modal')
}
</script>

<template>
    <div class="div-modal" v-if="showValidationTypeModal">
        <div class="div-modal-content">
            <div class="close-modal">
                <i class="fas fa-times" @click="emit('close-modal')"></i>
            </div>

            <div class="modal-body">
                <span class="d-flex justify-content-center fw-bold fs-5">
                    Que tipo de validação pretende solicitar?
                </span>
                <br>
                <span>
                    A validação comum não exige a anexação de documento comprovativo de competência. Já a validação com certificado requer o envio de pelos menos um comprovativo de competência.
                </span>
                <br>
                <div class="d-flex justify-content-end gap-3">
                    <button class="ddl-alt-padding" @click="requestValidation(false);">
                        Validação Comum
                    </button>
                    <button class="ddl-alt-padding" @click="requestValidation(true);">
                        Validação por Certificado
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>

.div-modal {
  position: fixed;
  color: var(--default-font-color);
}

.div-modal-content {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 30% !important;
}

.close-modal {
  display: flex;
  justify-content: flex-end;
  padding: 10px 10px 0px 0px;
}

.modal-body {
    padding: 0px 10px 10px 10px;
    display: flex;
    flex-direction: column;
}

.close-modal i {
  font-size: 1.5em;
  cursor: pointer;
}

.close-modal i:hover {
  color: var(--default-app-hover-color);
}

@media screen and (max-width: 990px) {
  .div-modal-content {
    width: 80% !important;
  }
}

</style>